import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import {
  AccordionMarriage,
  RegistrationMarriageFormVM,
  SearchMarriageFormVM,
} from 'mutation/view-models/registration-marriage';
// import ErrorModal from 'mutation/components/shared/error-modal';
import { PersonalDataSearchVM } from 'shell/view-models/personal-data';
import { transformMarriage } from 'shell/utils/consult-person/response-transformer/marital-status/marriage';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { initialValuesRegistrationMarriage } from 'mutation/utils/transformer-registration-marriage';
import PmiDivider from 'shell/components/shared/divider';
import ResearchSipoPerson from 'shell/components/shared/research-sipo-accordion';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { generatePath, useParams } from 'react-router-dom';

interface SearchMarriageFormProps {
  disabled?: boolean;
  values?: SearchMarriageFormVM;
  onChange: (
    key: keyof RegistrationMarriageFormVM,
    value: RegistrationMarriageFormVM[keyof RegistrationMarriageFormVM]
  ) => void;
  onChangeValues: (values: RegistrationMarriageFormVM) => void;
  editSipoUrl?: string;
  marriageData?: AccordionMarriage;
}

const SearchMarriageFormComponent = ({
  onChangeValues,
  values,
  marriageData,
  editSipoUrl = '/mutazioni/persona/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo',
}: SearchMarriageFormProps): React.ReactElement => {
  const { idIntestatario, idSchedaSoggettoANPR } = useParams();

  // const onCloseErrorModal = useEventCallback((value: boolean) => {
  //   setOpenError(value);
  // });

  const onSearchPersonEnd = useEventCallback((fields: PersonalDataSearchVM) => {
    const newMarriageData = transformMarriage(fields.subjectData || {});

    const person = transformPerson(fields.subjectData || {});

    // const canBeMutated = checkPersonRegistrationMarriage(
    //   fields?.subjectData?.statoCivile?.statoCivile
    // );

    // if (!canBeMutated) {
    //   // persona già coniugata
    //   setOpenError(true);
    //   return;
    // }

    onChangeValues({
      searchMarriage: {
        ...initialValuesRegistrationMarriage.searchMarriage,
        ...fields,
      },
      marriage: {
        ...initialValuesRegistrationMarriage.marriage,
        ...(marriageData || {}),
        ...(newMarriageData || {}),
        generality: fields.generality,
        person,
      },
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ResearchSipoPerson
          onSearchEnd={onSearchPersonEnd}
          url={`${__PERSON_API_URL__}/non-residenti/ricerca-intestatario-matrimonio`}
          redirectPath={generatePath(editSipoUrl, {
            idIntestatario,
            idSchedaSoggettoANPR,
          })}
          initialValues={values ? { filter: values } : undefined}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      {/* <ErrorModal open={openError} onClose={onCloseErrorModal} /> */}
    </Grid>
  );
};

SearchMarriageFormComponent.displayName = 'search marriage form component';

const SearchMarriageForm = memo(SearchMarriageFormComponent);

export default SearchMarriageForm;
